import axios from "../../axios";
import {
  GET_APPOINTMENT_LIST,
  GET_RESOURCE_LIST,
  GET_APPOINTMENT_DETAIL,
  CREATE_APPOINTMENT,
  UPDATE_STATUS,
  UPDATE_APPOINTMENT,
  RELOAD_CALENDAR,
  SELECT_RESOURCE,
  GET_FILTERED_LIST,
  CREATE_BLOCK_TIME,
  DELETE_BLOCK_TIME,
  CHECKOUT,
  GET_APPOINTMENT_SPECIFIC_DATE,
  CHECK_UPDATE,
  GET_LIST_SEARCH,
  DRAG_DROP_UPDATE,
  GET_DEPOSIT_LIST,
  GET_DEPOSIT_DETAIL,
  MAKE_DEPOSIT_REFUND,
  RELOAD_DEPOSIT_LIST,
  CHARGE_DEPOSIT,
  EXPORT_APPOINTMENT,
  INITIALIZE_PAYMENT, ADD_STRIPE_PAYMENT_METHOD
} from "./appointmentTypes";
import {
  LIST_ALL,
  LIST_RESOURCE,
  APPOINTMENT_DETAIL,
  URL_CREATE_APPOINTMENT,
  URL_UPDATE_STATUS,
  URL_UPDATE_APPOINTMENT,
  URL_CREATE_BLOCK_TIME,
  URL_DELETE_BLOCK_TIME,
  URL_CHECKOUT,
  URL_GET_APPOINTMENT_SPECIFIC_DATE,
  URL_CHECK_UPDATE,
  LIST_SEARCH,
  DRAG_DROP_UPDATE_URL,
  URL_MAKE_DEPOSIT_REFUND,
  URL_RELOAD_DEPOSIT_LIST,
  URL_GET_DEPOSIT_LIST,
  URL_GET_DEPOSIT_DETAIL,
  URL_CHARGE_DEPOSIT,
  URL_EXPORT_APPOINTMENT,
  URL_INITIALIZE_PAYMENT, URL_ADD_STRIPE_PAYMENT_METHOD
} from "./appointmentUrls";

import { ResponseModel } from '../../models/network/response_model'

export default {
  [GET_APPOINTMENT_LIST]({ commit }, params) {
    return new Promise((resolve) => {
      axios.get(LIST_ALL, {
        params: params
      }).then(async (response) => {
        let responseModel = new ResponseModel(response);
        await commit(GET_APPOINTMENT_LIST, responseModel.result.data);
        resolve();
      });
    })
  },

  [GET_RESOURCE_LIST]({ commit }, params) {
    axios.get(LIST_RESOURCE, {
      params: params
    }).then((response) => {
      let responseModel = new ResponseModel(response);
      commit(GET_RESOURCE_LIST, responseModel.result.data);
    });
  },

  [GET_APPOINTMENT_DETAIL]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(APPOINTMENT_DETAIL, {
        params: params
      }).then((response) => {
        let responseModel = new ResponseModel(response);
        if (responseModel.status == "FAIL") {
          commit(GET_APPOINTMENT_DETAIL, []);
          reject("This appointment is cancelled");
        } else if (responseModel.status == "OK") {
          commit(GET_APPOINTMENT_DETAIL, responseModel.result.data);
          resolve();
        } else {
          reject("Appointment fetching error");
        }
      });
    })
  },

  [CREATE_APPOINTMENT]({ dispatch }, data) {
    axios.post(`${URL_CREATE_APPOINTMENT}`, data)
      .then(() => {
        dispatch(RELOAD_CALENDAR);
      })
      .catch((error) => { console.log(error) });
  },

  [UPDATE_APPOINTMENT]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_APPOINTMENT}`, data)
        .then((response) => {
          dispatch(RELOAD_CALENDAR);
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) });
    })
  },

  [UPDATE_STATUS]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_UPDATE_STATUS}`, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  async [RELOAD_CALENDAR]({ dispatch, state, commit }, data) {
    if (data != null) {
      commit(RELOAD_CALENDAR, data);
    }
    await dispatch(GET_APPOINTMENT_LIST, state.calendarView);
    await dispatch(GET_RESOURCE_LIST, state.calendarView);

    await commit(GET_FILTERED_LIST);
  },

  [SELECT_RESOURCE]({ commit, dispatch }, data) {
    commit(SELECT_RESOURCE, data);
    dispatch(RELOAD_CALENDAR);
  },

  [GET_FILTERED_LIST]({ commit }) {
    commit(GET_FILTERED_LIST);
  },

  [CREATE_BLOCK_TIME]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_CREATE_BLOCK_TIME}`, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_BLOCK_TIME]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${URL_DELETE_BLOCK_TIME}`, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECKOUT]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_CHECKOUT, data)
        .then(() => {
          dispatch(RELOAD_CALENDAR);
          resolve();
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_APPOINTMENT_SPECIFIC_DATE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_APPOINTMENT_SPECIFIC_DATE, {
        params: params
      })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          resolve();
          commit(GET_APPOINTMENT_SPECIFIC_DATE, responseModel.result.data);
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECK_UPDATE]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_CHECK_UPDATE, {
        params: params
      })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          commit(CHECK_UPDATE, responseModel.result.data);
          resolve(responseModel.result.data);
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_LIST_SEARCH]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(LIST_SEARCH, {
        params
      }).then((response) => {
        let responseModel = new ResponseModel(response);
        commit(GET_LIST_SEARCH, responseModel.result.data);
        resolve(responseModel.result.data);
      })
        .catch((error) => { reject(error) });
    })
  },

  [DRAG_DROP_UPDATE]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(DRAG_DROP_UPDATE_URL, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == "OK") {
            dispatch(RELOAD_CALENDAR);
            resolve();
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_DEPOSIT_LIST]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_DEPOSIT_LIST, { params }).then((response) => {
        let responseModel = new ResponseModel(response);
        commit(GET_DEPOSIT_LIST, responseModel.result.data);
        resolve(responseModel.result.data);
      }).catch((error) => { reject(error) });
    })
  },

  [GET_DEPOSIT_DETAIL]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_DEPOSIT_DETAIL, { params }).then((response) => {
        let responseModel = new ResponseModel(response);
        commit(GET_DEPOSIT_DETAIL, responseModel.result.data);
        resolve(responseModel.result.data);
      }).catch((error) => { reject(error) });
    })
  },

  [MAKE_DEPOSIT_REFUND]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_MAKE_DEPOSIT_REFUND, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == "OK") {
            resolve(responseModel.result.data);
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [RELOAD_DEPOSIT_LIST]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_RELOAD_DEPOSIT_LIST, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == "OK") {
            resolve(responseModel.result.data);
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHARGE_DEPOSIT]({ dispatch }, data) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post(URL_CHARGE_DEPOSIT, data);
        resolve(true);
      } catch (error) {
        reject(error)
      }
    })
  },

  // eslint-disable-next-line
  [EXPORT_APPOINTMENT]({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_EXPORT_APPOINTMENT}`, { params: item })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => { console.log(error); reject(error) })
    })
  },

  [INITIALIZE_PAYMENT]({commit}, data) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(URL_INITIALIZE_PAYMENT, data);
        if(!response || !response.data || response.data.status !== 'OK') {
          throw new Error(response.message || 'Initialize payment error!')
        }
        resolve(response.data.result.data);
      } catch (error) {
        reject(error);
      }
    });
  },
  [ADD_STRIPE_PAYMENT_METHOD]({commit}, data) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(URL_ADD_STRIPE_PAYMENT_METHOD, data);
        if(!response || !response.data || response.data.status !== 'OK') {
          throw new Error(response.message || 'Add stripe payment method error!')
        }
        resolve(response.data.result.data);
      } catch (error) {
        reject(error);
      }
    });
  }
}
